var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { staticClass: "mb-3" }, [
      _c("label", [_vm._v(_vm._s(_vm.$t("links.linkCollection.model.name")))]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.collection.name,
            expression: "collection.name"
          }
        ],
        staticClass: "form-control",
        attrs: { type: "text" },
        domProps: { value: _vm.collection.name },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.collection, "name", $event.target.value)
          }
        }
      })
    ]),
    _vm._v(" "),
    _vm.showDescription
      ? _c("div", { staticClass: "mb-3" }, [
          _c("label", [
            _vm._v(_vm._s(_vm.$t("links.linkCollection.model.description")))
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.collection.description,
                expression: "collection.description"
              }
            ],
            staticClass: "form-control",
            attrs: { type: "text" },
            domProps: { value: _vm.collection.description },
            on: {
              input: function($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.collection, "description", $event.target.value)
              }
            }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "mb-3" }, [
      _c("label", [_vm._v(_vm._s(_vm.$t("links.linkCollection.model.css")))]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.collection.customCss,
            expression: "collection.customCss"
          }
        ],
        staticClass: "form-control",
        attrs: { type: "text" },
        domProps: { value: _vm.collection.customCss },
        on: {
          input: function($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.collection, "customCss", $event.target.value)
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mb-3" }, [
      _c("input", {
        ref: "fileInput",
        staticClass: "btn btn-secondary",
        attrs: { type: "file" },
        on: { change: _vm.handleFileChange }
      }),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn btn-secondary", on: { click: _vm.setFile } },
        [
          _c("i", { staticClass: "fa fa-check" }),
          _vm._v(_vm._s(_vm.collection.backgroundImageName))
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn btn-secondary", on: { click: _vm.clearFile } },
        [
          _c("i", {
            staticClass: "fa fa-trash",
            attrs: { "aria-hidden": "true" }
          })
        ]
      )
    ]),
    _vm._v(" "),
    _c("table", { staticClass: "table table-striped" }, [
      _c("thead", [
        _c("tr", [
          _c("th", [_vm._v(_vm._s(_vm.$t("links.link.model.name")))]),
          _vm._v(" "),
          _vm.showDescription
            ? _c("th", [_vm._v(_vm._s(_vm.$t("links.link.model.description")))])
            : _vm._e(),
          _vm._v(" "),
          _c("th", [_vm._v(_vm._s(_vm.$t("links.link.model.url")))]),
          _vm._v(" "),
          _c("th", [_vm._v(_vm._s(_vm.$t("links.link.model.newTab")))]),
          _vm._v(" "),
          _c("th", [_vm._v(_vm._s(_vm.$t("links.editModal.list.actions")))])
        ])
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        [
          _vm._l(_vm.links, function(link, i) {
            return _c("tr", { staticStyle: { height: "1px" } }, [
              _c("td", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: link.name,
                      expression: "link.name"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: link.name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(link, "name", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _vm.showDescription
                ? _c("td", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: link.description,
                          expression: "link.description"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text" },
                      domProps: { value: link.description },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.$set(link, "description", $event.target.value)
                        }
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("td", [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: link.url,
                      expression: "link.url"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text" },
                  domProps: { value: link.url },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.$set(link, "url", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c(
                "td",
                { staticClass: "h-100" },
                [
                  _c("CenterOnParent", [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: link.newTab,
                          expression: "link.newTab"
                        }
                      ],
                      staticClass: "form-check",
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(link.newTab)
                          ? _vm._i(link.newTab, null) > -1
                          : link.newTab
                      },
                      on: {
                        change: function($event) {
                          var $$a = link.newTab,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(link, "newTab", $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  link,
                                  "newTab",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(link, "newTab", $$c)
                          }
                        }
                      }
                    })
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("td", [
                _c("div", { staticClass: "btn-group" }, [
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "visible",
                          rawName: "v-visible",
                          value: i + 1 < _vm.links.length,
                          expression: "i + 1 < links.length"
                        }
                      ],
                      staticClass: "btn btn-secondary",
                      on: {
                        click: function($event) {
                          return _vm.moveDown(i)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-arrow-down" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "visible",
                          rawName: "v-visible",
                          value: i > 0,
                          expression: "i > 0"
                        }
                      ],
                      staticClass: "btn btn-secondary",
                      on: {
                        click: function($event) {
                          return _vm.moveUp(i)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-arrow-up" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-danger",
                      on: {
                        click: function($event) {
                          return _vm.links.splice(i, 1)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-trash" })]
                  )
                ])
              ])
            ])
          }),
          _vm._v(" "),
          _c("tr", [
            _c(
              "td",
              { attrs: { colspan: 4 + (_vm.showDescription ? 1 : 0) } },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-success",
                    on: { click: _vm.addLink }
                  },
                  [_c("i", { staticClass: "fa fa-plus" })]
                )
              ]
            )
          ])
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }